module.exports = __webpack_public_path__ + "img/mianyi2.c06dec7d.png";